import React from "react"
import autobind from "class-autobind"
import { Dialog, TextField, FlatButton } from "material-ui"
import strings from "../../../localization/strings"
import Clear from "../../misc/Clear"
import { IPosition } from "../../../models"
import PositionsTable from "../PositionsTable"

interface IProps {
    candidatePositions: IPosition[]
    handleClose(): void
    handleUpdate(selectedPositions: IPosition[]): void
}
interface IState {
    search: string
    selectedPositions: IPosition[]
    filteredPositions: IPosition[]
}

export default class AddAccountPositionDialogForChip extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            search: "",
            selectedPositions: [],
            filteredPositions: []
        }
        autobind(this)
    }

    componentDidMount() {
        this.getFilteredPositions()
    }

    getFilteredPositions() {
        const filteredPositions = this.props.candidatePositions
            .filter(item => this.state.search ?
                item.Name.toLowerCase().includes(this.state.search.toLowerCase()) ||
                (item.ExternalId && item.ExternalId.toLowerCase().includes(this.state.search.toLowerCase())) :
                true
            )
        this.setState({
            filteredPositions,
            selectedPositions: []
        })
    }

    render() {
        return (
            <Dialog
                open
                modal
                title={strings.Select_Positions}
                actions={[
                    <FlatButton
                        data-intercom-target={"Btn-Close-Account-Position-Selection-Dialog"}
                        label={strings.Cancel}
                        secondary
                        onClick={this.props.handleClose}
                    />,
                    <FlatButton
                        data-intercom-target={"Btn-Save-Selected-Account-Position"}
                        label={strings.OK}
                        primary
                        keyboardFocused
                        disabled={this.state.selectedPositions.length === 0}
                        onClick={() => this.props.handleUpdate(this.state.selectedPositions)}
                    />
                ]}
                onRequestClose={this.props.handleClose}
            >
                <div data-intercom-target={"Position-Selection-Dialog"}>
                    <div style={{ padding: 20, paddingLeft: 35 }}>
                        <i style={{ fontSize: 25 }} className="fa fa-search" />
                        <TextField
                            style={{ marginRight: 20, width: "90%", marginLeft: 15 }}
                            hintText={strings.search}
                            value={this.state.search}
                            onChange={e => this.setState({ search: e.target.value }, () => this.getFilteredPositions())}
                        />
                        <Clear />
                    </div>
                    <PositionsTable
                        isDialog
                        positions={this.state.filteredPositions}
                        selectedPositions={this.state.selectedPositions}
                        handleSelect={selectedPositions => this.setState({ selectedPositions })}
                    />
                </div>
            </Dialog>
        )
    }
}
